import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, FlexBox, Tabs } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import { useState } from 'react';
import styles from './conversationReply.module.scss';
/** Represents the reply section tabs. */
const tabs = [
    { id: 'outbound', label: 'Answer' },
    { id: 'internal', label: 'Internal note' },
];
const accentColors = {
    outbound: 'neutral',
    internal: 'orange',
};
/** Represents the reply section of the conversation main view. */
export const ConversationReply = () => {
    const [replyTabId, setReplyTabId] = useState('outbound');
    const accentColor = accentColors[replyTabId];
    return (_jsxs(FlexBox, Object.assign({ className: styles.root, flexDirection: "column", borderRadius: "100", borderColor: colors[accentColor][200] }, { children: [_jsxs(FlexBox, Object.assign({ className: styles.header, gap: "200", alignItems: "center", justifyContent: "space-between", padding: "0 300", background: colors[accentColor][100] }, { children: [_jsx(Tabs, { selectedId: replyTabId, tabs: tabs, onChange: (tabId) => setReplyTabId(tabId) }), _jsx(Button, Object.assign({ variant: "tertiary" }, { children: "Actions" }))] })), _jsx(Box, Object.assign({ flex: "1" }, { children: replyTabId }))] })));
};
